var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 352 238"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "navbar-cloud-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1849",
    "data-name": "Rectangle 1849",
    width: 352,
    height: 238,
    transform: "translate(-1 843)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "navbar-cloud-linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34e4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ac9e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "navbar-cloud-linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34e4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9fcfd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_72",
    "data-name": "Mask Group 72",
    transform: "translate(1 -843)",
    clipPath: "url(#navbar-cloud-clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13796",
    "data-name": "Group 13796",
    transform: "translate(-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21210",
    "data-name": "Path 21210",
    d: "M843.864,327.568s-58.919-6.725-62.953,60.523c0,0-50.436-3.363-58.506,49.763.184-1.209-3.078-4.568-3.741-5.4-11.943-15.01-31.131-21.684-50.007-18.256-23.028,4.182-40.691,23.392-46.664,45.487,1.173-4.339-9.628-7.043-12.417-8.029a56.057,56.057,0,0,0-18.753-3.147c-13.714.022-29.117,4.781-38.11,15.574,1.647-1.976-15.666-14.108-17.079-14.857-17.135-9.087-36.223-5.155-51.958,4.771,2.262-1.427-9.242-19.824-10.893-21.853-7.008-8.613-17.441-14.853-28.1-17.678-21.758-5.762-47.3,2.38-60.295,21.032,2.161-3.1-4-15.327-5.5-18.21a54.045,54.045,0,0,0-13.5-16.642c-12-9.885-26.977-12.719-42.2-11.92A55.209,55.209,0,0,0,308.6,344.014c-12.792-13.395-29.332-16.956-47.134-16.625,2.231,39.938.093,80.917.093,121.026v56.3H843.864Z",
    transform: "translate(-364.017 574.861)",
    opacity: 0.5,
    fill: "url(#navbar-cloud-linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12980",
    "data-name": "Group 12980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21211",
    "data-name": "Path 21211",
    d: "M741.2,327.533s-48.533-5.539-51.857,49.855c0,0-41.545-2.77-48.193,40.991.151-1-2.536-3.763-3.082-4.449-9.838-12.364-25.643-17.862-41.192-15.038-18.969,3.445-33.518,19.268-38.439,37.469.966-3.574-7.931-5.8-10.228-6.614a46.177,46.177,0,0,0-15.448-2.593c-11.3.018-23.985,3.938-31.392,12.829,1.356-1.628-12.9-11.621-14.068-12.238-14.115-7.485-29.838-4.246-42.8,3.93,1.863-1.175-7.613-16.33-8.973-18a45.271,45.271,0,0,0-23.151-14.562c-17.923-4.747-38.961,1.961-49.666,17.324,1.78-2.554-3.294-12.625-4.533-15a44.519,44.519,0,0,0-11.121-13.709c-9.882-8.142-22.222-10.477-34.763-9.819a45.477,45.477,0,0,0-12.008-36.827c-10.537-11.033-24.162-13.967-38.825-13.694,1.837,32.9.076,66.654.076,99.693l-.465,144.386,480.111-.035Z",
    transform: "translate(-261.205 508.632)",
    opacity: 0.4,
    fill: "url(#navbar-cloud-linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12978",
    "data-name": "Group 12978"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_682",
    "data-name": "Ellipse 682",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 396.947, 1031.713)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_683",
    "data-name": "Ellipse 683",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 298.474, 902.356)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_684",
    "data-name": "Ellipse 684",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 85.701, 963.32)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_685",
    "data-name": "Ellipse 685",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 225.474, 1067.356)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_817",
    "data-name": "Ellipse 817",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 159.474, 1003.356)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_818",
    "data-name": "Ellipse 818",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 53.474, 1031.356)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_816",
    "data-name": "Ellipse 816",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "matrix(-0.819, -0.574, 0.574, -0.819, 459.474, 963.356)",
    fill: "url(#navbar-cloud-linear-gradient-3)"
  })))))));
};

export default __webpack_public_path__ + "static/media/navbarClouds.716b1ca1.svg";
export { SvgComponent as ReactComponent };